import { Goal2030Model, ProjectLinkedOutcomeModel } from "../../../../../../hub_schema/hubTypes";

export class LinkedOutcomeTree {
    public projectType: string;
    public linkedOutcomeLists: LinkedOutcomeList[];
    public get hasOutcomes(): boolean {
        return this.linkedOutcomeLists.some(lol => lol.linkedOutcomes.length);
    }

    public constructor(projectType: string, goals: Goal2030Model[], linkedOutcomes: ProjectLinkedOutcomeModel[]) {
        this.projectType = projectType;
        this.linkedOutcomeLists = [];

        goals.forEach((goal: Goal2030Model) => {
            const goalOutcomes =  linkedOutcomes.filter(lo => lo.projectOutcome!.outcome!.outcomeMetric!.goal2030Id === goal.goal2030Id);

            if (goalOutcomes.length) {
                const linkedOutcomeList = new LinkedOutcomeList(goal, goalOutcomes);
                this.linkedOutcomeLists.push(linkedOutcomeList);
            }
        });
    }
}

export class LinkedOutcomeList {
    public goal: Goal2030Model;
    public linkedOutcomes: ProjectLinkedOutcomeModel[];

    public constructor(goal: Goal2030Model, linkedOutcomes: ProjectLinkedOutcomeModel[]) {
        this.goal = goal;
        this.linkedOutcomes = linkedOutcomes;
    }
}
